import { Theme } from "@mui/material";
import { createTheme } from "@mui/material/styles";

export const fernieColors = {
	dim: "#5F6F6A",
	fern: "#69936C",
	led: "#A1DBA6",
	richSoil: "#3F4948",
	springSoft: "#CDEBD0",
	tile: "#2C3433"
} as const;

export const FERNIE_FONT_NAME = "'Montserrat', sans-serif";
export const FERNIE_FONT_VOICE = "'IBM Plex Mono', monospace";
export const FERNIE_FONT_CODE = "'JetBrains Mono', 'Roboto Mono', monospace";

declare module "@mui/material/styles" {
	interface Palette {
		fernie: typeof fernieColors;
	}

	interface PaletteOptions {
		fernie?: typeof fernieColors;
	}
}

interface FernieBrandThemeOptions {
	shouldApplyBrandFont?: boolean;
}

export function createFernieBrandTheme(
	outerTheme: Theme,
	{ shouldApplyBrandFont = true }: FernieBrandThemeOptions = {}
): Theme {
	const brandFont = shouldApplyBrandFont ? outerTheme.typography.brandFont : undefined;
	return createTheme(outerTheme, {
		palette: {
			primary: {
				contrastText: "#FFFFFF",
				dark: fernieColors.richSoil,
				light: fernieColors.springSoft,
				main: fernieColors.fern
			}
		},
		typography: brandFont ? { allVariants: { fontFamily: brandFont }, fontFamily: brandFont } : {}
	});
}

// MUI v7 bakes fontFamily into every resolved variant and InputBase, so each must be named to re-theme.
export function createFernieFontTheme(outerTheme: Theme, fontFamily: string): Theme {
	const family = { fontFamily };
	return createTheme(outerTheme, {
		components: {
			MuiInputBase: {
				styleOverrides: {
					input: family,
					root: family
				}
			}
		},
		typography: {
			body1: family,
			body2: family,
			brandFont: fontFamily,
			button: family,
			caption: family,
			fontFamily,
			h1: family,
			h2: family,
			h3: family,
			h4: family,
			h5: family,
			h6: family,
			overline: family,
			subtitle1: family,
			subtitle2: family
		}
	});
}
